import { CreationInformationItem, ValidationErrors } from "../../../services/types";
import strings from "../../../strings";
import * as Fields from "./Fields";

export interface DistrictFull extends CreationInformationItem {
  id: number;
  name: string;
  order: number;
}

export interface DistrictForm {
  name: string | null;
  order: number | null;
}

export interface DistrictPost {
  name: string;
  order: number;
}

export const mapToPOST = (item: DistrictForm): DistrictPost => {
  return {
    name: item.name || "",
    order: item.order || 0,
  };
};

export const validate = (
  state: DistrictForm,
  setErrors: React.Dispatch<React.SetStateAction<ValidationErrors>>,
): boolean => {
  const errors: ValidationErrors = {};
  if (!state.name) {
    errors[Fields.name.fieldName] = strings.required;
  }
  if (!state.order) {
    errors[Fields.order.fieldName] = strings.required;
  }
  setErrors(errors);
  return Object.keys(errors).length === 0;
};
